import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as PresetProfileActions from "../../store/repIQPresetProfile/actions";
import * as SocialMediaStatusActions from "../../store/repIQSocialMediaStatus/actions";
import * as SocialMediaAnalysisHistoryAction from "../../store/repIQSocialMediaAnalysisHistory/actions";
import GettingStarted from "./GettingStarted";
import ReputationAnalyzer from "./ReputationAnalyzer";
import ReputationTab from "./ReputationTab";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";

const Reputation = (props: any) => {
    const dispatch = useDispatch();
    const getPresetProfileData = () => dispatch(PresetProfileActions.actionCreators.getPresetProfileData());
    const getSocialMediaStatus = (forceReload: boolean) => dispatch(SocialMediaStatusActions.actionCreators.getUserNetworkStatus(forceReload));
    const getSocialMediaAnalysisHistory = (forceReload: boolean) =>
        dispatch(SocialMediaAnalysisHistoryAction.actionCreators.getSocialMediaAnalysisHistory(forceReload));
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        getPresetProfileData();
        getSocialMediaStatus(true);
        getSocialMediaAnalysisHistory(false);
    });

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12">
                    <h1 className="title-page" id="reputation-title-page" tabIndex={-1}>
                        Online Reputation
                    </h1>
                </div>
            </div>

            <ReputationTab selectedTab="1" />

            <div className="row" id="content">
                <div className="col-xs-12">
                    <GettingStarted />
                    <ReputationAnalyzer />
                </div>
            </div>
        </React.Fragment>
    );
};

export default Reputation;
